window.pcEvents = []
window.pureClarity = () => {
  if (typeof _pc !== 'undefined') {
    let context = {}
    const productDataEl = document.querySelector('#product_detail .specification[data-code]')
    if (productDataEl) {
      context = {
        page_type: 'product_page',
        product_id: productDataEl.dataset.code,
        category_id: productDataEl.dataset.category
      }
    }

    const categoryDataEl = document.querySelector('.category-products[data-id')
    if (categoryDataEl) {
      context = {
        page_type: 'product_listing_page',
        category_id: categoryDataEl.dataset.id
      }
    }

    _pc("page_view", context)
    _pc("currency", document.body.dataset.currency)
  } else {
    'not yet'
  }
}

window.pureClarityInit = () => {
  window.pcEvents.forEach(e => {
    _pc(e.name, e.context)
  })
  window.pcEvents = []
}

window.pcEventsPush = (e) => {
  if (typeof _pc !== 'undefined') {
    _pc(e.name, e.context)
  } else {
    window.pcEvents.push(e)
  }
}